import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, AddUserToGroup, CheckGroupName } from '../../../functions/ZIA'
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBroom, faPaste, faCopy, faI, faL } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CSVReader from 'react-csv-reader';
import Papa from 'papaparse';
import { Regex } from 'react-bootstrap-icons';

library.add(faBroom, faPaste, faCopy)

function FilterIpsTab({ groups }) {
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("")
    const [valid, setValid] = useState(false);
    const [outputConsole, setOutputConsole] = useState("");
    const [ipList, setIpList] = useState([])
    const [data, setData] = useState()
    const textareaRef = useRef();
    const IP_REGEX = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/;

    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + "\t" + dashes);
    }
    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }

    function extractIPs(event) {
        {
            event.preventDefault()
            const dataToParse = data;
            setLoading(true)
            setIpList([])
            var uniqueIpSet = new Set();
            if (selectFile) {
                //Get index of Client IP column
                var ipIndex = -1;
                for (var i = 0; i < 10; i++) {
                    if (dataToParse[i][0] == "No.") {
                        ipIndex = dataToParse[i].indexOf("Client IP")
                    }
                }
                if (ipIndex < 0) {
                    setOutputConsole("Client IP header not gound")
                    setLoading(false)
                    return;
                }
                //Loop over the column to get all IPs
                for (const row of dataToParse) {
                    if (IP_REGEX.test(row[ipIndex])) {
                        uniqueIpSet.add(row[ipIndex])

                    } else {
                        console.log("Not valid IP: " + row[ipIndex])
                    }
                }
                console.log(uniqueIpSet);
                const ipArray = Array.from(uniqueIpSet);
                setIpList(ipArray);
                outputResult(ipArray)
                setLoading(false)

            }
        }
    }

    function selectFile(e) {
        const files = e.target.files;
        console.log(files);
        if (files) {
            console.log(files[0]);
            Papa.parse(files[0], {
                complete: function (results) {
                    setData(results.data)
                }
            }
            )
        }

    }



    function copyList(list) {
        const text = ListToText(list);
        navigator.clipboard.writeText(text);
    }

    function ListToText(list) {
        let text = "";
        for (let i = 0; i < list.length; i++) {
            text += i === 0 ? list[i] : "\n" + list[i];
        }
        return text;
    }

    function outputResult(ips) {
        setOutputConsole("IPs Found: " + ips.length)
        appendConsoleSeperatorMain()
        var index = 1;
        ips.forEach(ip => {
            appendConsole("\n" + index++ + " - " + ip);
        });
    }



    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Form onSubmit={extractIPs}>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Upload .csv File</Form.Label>
                    <Row>
                        <Col>
                            <Form.Control type="file" accept=".csv" onChange={(e) => selectFile(e)} />

                        </Col>
                        <Col xs="auto">
                            <Button className='text-light' variant="primary" type='submit' disabled={isLoading || !data} >
                                {isLoading ?
                                    <span>
                                        <Spinner
                                            variant='light'
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        {"  " + loadingMessage}
                                    </span> : 'Submit'}
                            </Button>
                        </Col>
                    </Row>

                </Form.Group>

            </Form>

            <Row className='mt-5 '>
                <Col md="auto" className='text-end'>
                    <Button disabled={ipList.length > 0 ? false : true} onClick={(event) => { copyList(ipList) }} className='rounded-0 pt-0 pb-0 pm-1' size='sm' variant={ipList.length > 0 ? 'success' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy IPs
                        <Badge className='ms-1 ' bg="dark">{ipList.length}</Badge>
                    </Button>
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle  text-rheintec-blue' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>
        </Container >

    );

}

export default FilterIpsTab;